import FlagUS from '@Assets/icons/flags/us.svg';
import FlagGB from '@Assets/icons/flags/gb.svg';
import FlagCA from '@Assets/icons/flags/ca.svg';
import FlagDE from '@Assets/icons/flags/de.svg';
import FlagFR from '@Assets/icons/flags/fr.svg';
import FlagIN from '@Assets/icons/flags/in.svg';
import FlagIT from '@Assets/icons/flags/it.svg';
import FlagES from '@Assets/icons/flags/es.svg';
import FlagMX from '@Assets/icons/flags/mx.svg';
import FlagJP from '@Assets/icons/flags/jp.svg';

export type MarketplaceCode = 'all' | 'US' | 'UK' | 'CA' | 'DE' | 'FR' | 'IN' | 'IT' | 'ES' | 'MX' | 'JP';
export type MarketplaceCountryCode = Exclude<MarketplaceCode, 'all'>;

export interface MarketplaceOption {
    code: MarketplaceCountryCode;
    value: string;
    label: string;
    flag: { src: string };
    nameKey: string;
    icon: string;
}

export const MARKETPLACES: MarketplaceOption[] = [
    { code: 'US', value: 'US', label: 'USA', flag: FlagUS, nameKey: 'scout.productResearch.marketplaces.us', icon: '🇺🇸' },
    { code: 'UK', value: 'UK', label: 'UK', flag: FlagGB, nameKey: 'scout.productResearch.marketplaces.uk', icon: '🇬🇧' },
    { code: 'CA', value: 'CA', label: 'Canada', flag: FlagCA, nameKey: 'scout.productResearch.marketplaces.ca', icon: '🇨🇦' },
    { code: 'DE', value: 'DE', label: 'Germany', flag: FlagDE, nameKey: 'scout.productResearch.marketplaces.de', icon: '🇩🇪' },
    // { code: 'FR', value: 'FR', label: 'France', flag: FlagFR, nameKey: 'scout.productResearch.marketplaces.fr', icon: '🇫🇷' },
    { code: 'IN', value: 'IN', label: 'India', flag: FlagIN, nameKey: 'scout.productResearch.marketplaces.in', icon: '🇮🇳' },
    { code: 'IT', value: 'IT', label: 'Italy', flag: FlagIT, nameKey: 'scout.productResearch.marketplaces.it', icon: '🇮🇹' },
    { code: 'ES', value: 'ES', label: 'Spain', flag: FlagES, nameKey: 'scout.productResearch.marketplaces.es', icon: '🇪🇸' },
    { code: 'MX', value: 'MX', label: 'Mexico', flag: FlagMX, nameKey: 'scout.productResearch.marketplaces.mx', icon: '🇲🇽' },
    { code: 'JP', value: 'JP', label: 'Japan', flag: FlagJP, nameKey: 'scout.productResearch.marketplaces.jp', icon: '🇯🇵' },
];
